export default class Ai {
  constructor(cscom) {
    if (!(this instanceof Ai)) {
      return new Ai(cscom);
    }
    this.cscom = cscom;
  }

  promptCubeJsQuestion(question) {
    return this.cscom.req.post("/api/rest/talink/ai/prompt-cubejs-question", {
      question,
    });
  }

  promptCubeJsSchema(question) {
    return this.cscom.req.post("/api/rest/talink/ai/prompt-cubejs-schema", {
      question,
    });
  }
}
